<template>
  <div @click="goBack" id="root">
    {{ $cte("common.error") }}
  </div>
</template>
<script>
export default {
  methods: {
    goBack() {
      this.$router.push("/");
    },
  },
};
</script>
